import React, { useState } from "react";
import { useFormik } from 'formik';
import SingleSelectFormField from "../SingleSelectFormField";
import axios from 'axios';
import classNames from "../../utils";
import toast from 'react-hot-toast';
import SelectTypeCar from "../SelectTypeCar";
import ErrorMassage from "../ErrorMassage";
import {Link} from "react-router-dom";
import SelectLng from "../SelectLng";


const Courier = ({ setIsOpenMobileNav }) => {
  const [access, setAccess] = useState(true);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);


  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      state_id: '',
      city_id: '',
      car_type: '',
      car_name: '',
      language: ''
    },
    onSubmit: async (values) => {
      setIsSubmitting(true);
      const payload = { ...values };

      try {
        const response = await axios.post('https://api.dom-food.com/page/register-courier', payload);
        console.log('Form submitted successfully:', response.data);
        setIsOpenMobileNav(false)
        toast.success('Ваша учетная запись создана и ожидает одобрения от администратора.')
      } catch (error) {
        setErrors(error.response.data.errors);
        console.error('Error submitting form:', error);
      }
      finally {
        setIsSubmitting(false);
      }
    },
  });

  const checkAccess = () => {
    setAccess(!access);
  };

  return (
    <>
      <p className="text-base md:text-2xl text-[#333F51] font-normal my-4 sm:my-0 font-custom">Мы перезвоним вам в течение <span className="text-[#333F51] font-bold">10 минут</span></p>
      <form onSubmit={formik.handleSubmit} className="space-y-4 mt-4 px-4 md: overflow-y-auto max-h-80">
      <input
        name="first_name"
        value={formik.values.first_name}
        onChange={formik.handleChange}
        className="hover:border-orange-500 border border-1 border-gray-400 rounded-full h-[45px] max-w-[650px] px-[20px] w-full"
        placeholder="Имя"
      />
      { errors.first_name && <ErrorMassage message={errors.first_name} /> }

      <input
        name="last_name"
        value={formik.values.last_name}
        onChange={formik.handleChange}
        className="hover:border-orange-500 border border-1 border-gray-400 rounded-full h-[45px] max-w-[650px] px-[20px] w-full"
        placeholder="Фамилия"
      />
      { errors.last_name && <ErrorMassage message={errors.last_name} /> }

      <input
        type="email"
        name="email"
        value={formik.values.email}
        onChange={formik.handleChange}
        className="hover:border-orange-500 border border-1 border-gray-400 rounded-full h-[45px] max-w-[650px] px-[20px] w-full"
        placeholder="Эл. Почта*"
      />
      { errors.email && <ErrorMassage message={errors.email} /> }

      <input
        name="phone"
        value={formik.values.phone}
        onChange={formik.handleChange}
        className="hover:border-orange-500 border border-1 border-gray-400 rounded-full h-[45px] max-w-[650px] px-[20px] w-full"
        placeholder="+7 (xxx) xxx xx xx"
      />
      { errors.phone && <ErrorMassage message={errors.phone} /> }

      <p className="text-[#333F51] text-lg text-start">Область</p>
      <SingleSelectFormField
        formik={formik}
      />
      { errors.state_id && <ErrorMassage message={errors.state_id} /> }
      { errors.city_id && <ErrorMassage message={errors.city_id} /> }


      <p className="text-[#333F51] text-lg text-start">Вид транспорта</p>
      <SelectTypeCar
        formik={formik}
      />
      { errors.car_type && <ErrorMassage message={errors.car_type} /> }

      {formik.values.car_type === "Автомобиль" && (
          <input
              name="car_name"
              value={formik.values.car_name}
              onChange={formik.handleChange}
              className="mt-6 border border-1 border-gray-400 rounded-full h-[45px] max-w-[650px] px-[20px] w-full"
              placeholder="Название автомобиля"
              autoFocus
          />
      )}

          <SelectLng
              formik={formik}
          />

      <button
        disabled={access || isSubmitting}
        type="submit"
        className={classNames(access || isSubmitting ? 'cursor-not-allowed' : 'cursor-pointer', 'w-full mt-8 rounded-[30px] h-[52px] bg-gradient-to-r from-[#DE4333] to-[#FDA110] text-white px-10 font-bold')}
      >
        {isSubmitting ? 'Загрузка...' : 'Отправить заявку'}

      </button>
        <div className="flex gap-x-4">
          <input onChange={checkAccess} type="checkbox" />
          <label className="text-[#333F51] text-sm text-start">Я принимаю условия <Link className="text-[#FDA110] underline" target="_blank" to="https://dom-food.com/public_offer_courier">Публичной Оферты</Link> и <Link className="text-[#FDA110] underline" target="_blank" to="https://dom-food.com/user_agreement">Пользовательского Соглашения</Link>  а также соглашаюсь с <Link className="text-[#FDA110] underline" target="_blank" to="https://dom-food.com/privacy_policy">Политикой Конфиденциальности</Link> .</label>
        </div>
    </form>
    </>
  );
};

export default Courier;
